module.exports = __webpack_public_path__ + "img/icon-4.dcb5928b.png";